import storage from 'redux-persist/lib/storage';

export const jwtTokenManagerPersistConfig = {
  key: 'jwtTokenManager',
  storage,
};
